import { render, staticRenderFns } from "./ItemGridView.vue?vue&type=template&id=1a8f84e2&scoped=true&"
import script from "./ItemGridView.vue?vue&type=script&lang=js&"
export * from "./ItemGridView.vue?vue&type=script&lang=js&"
import style0 from "./ItemGridView.vue?vue&type=style&index=0&id=1a8f84e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f84e2",
  null
  
)

export default component.exports